import React from "react";
import "./ProjetNDBF.css";

const ProjetNDBF = () => {
    return (
        <div className="projet-ndbf-wrapper">
            {/* Première Section */}
            <div className="projet-section">
                <h2 className="section-title">Notre projet</h2>
                <p className="section-description">
                    Permettre à chaque licencié de s’épanouir dans la pratique du futsal, en fonction de son niveau,
                    ses aspirations et ses motivations. Nous exigeons de nos licenciés le respect des valeurs essentielles :
                    respect des partenaires, adversaires, arbitres, éducateurs et dirigeants.
                </p>
                <ul className="projet-list">
                    <li>Organisation de séances d’entraînement</li>
                    <li>Organisation de matchs le week-end</li>
                    <li>Organisation de stages durant les vacances</li>
                    <li>Organisation de tournois</li>
                </ul>
            </div>

            {/* Deuxième Section */}
            <div className="projet-section">
                <h2 className="section-title">Événements annuels organisés par le NDBF</h2>

                {/* Événements sportifs */}
                <h3 className="table-title">Événements sportifs</h3>
                <table className="projet-table">
                    <thead>
                    <tr>
                        <th>Type d’événement</th>
                        <th>Date</th>
                        <th>Participants</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>Tournoi U10-U11</td>
                        <td>Mai</td>
                        <td>120</td>
                    </tr>
                    <tr>
                        <td>Tournoi U12-U13</td>
                        <td>Mai</td>
                        <td>150</td>
                    </tr>
                    <tr>
                        <td>Tournoi U14-U15</td>
                        <td>Mai</td>
                        <td>150</td>
                    </tr>
                    </tbody>
                </table>

                {/* Événements non sportifs */}
                <h3 className="table-title">Événements non sportifs</h3>
                <table className="projet-table">
                    <thead>
                    <tr>
                        <th>Type d’événement</th>
                        <th>Date</th>
                        <th>Participants</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>Loto</td>
                        <td>Décembre</td>
                        <td>100</td>
                    </tr>
                    <tr>
                        <td>Vide Grenier</td>
                        <td>Septembre</td>
                        <td>120</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ProjetNDBF;
